/* eslint-disable */
'use client';
import { useTranslations } from 'next-intl';
import { useEffect, useRef } from 'react';
import { toastBase } from '@/fo/ui/kit/toast/base';
// import { CustomerData } from '@/fo/api/magento';
import {
  ResponseError,
  MindboxResponseBody,
  MINDBOX_OPERATIONS
} from '@/fo/api/mindbox';
import ArrowIcon from '@/fo/icons/base/icons/chevron.svg';
import IconBrand from '@/fo/icons/base/icons/bonus_dark.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitDrawerBase } from '@/fo/ui/kit/drawer/base';
import { utilPluralize } from '@/fo/util/pluralize';
import { UiKitInputBase } from '@/fo/ui/kit/input/base';
import { AccrualHistory } from '../AccrualHistory/AccrualHistory';

import { styles } from './MainInfo.styles';
type levelStatus = 'explorer' | 'innovator' | 'ambassador';
type LevelData = {
  title?: string | null;
  condition: string;
  action: string;
};
type MainInfoProps = {
  customerInfo:
    | MindboxResponseBody[typeof MINDBOX_OPERATIONS.GET_CUSTOMER_INFO]
    | ResponseError;
  customerBalanceHistory:
    | MindboxResponseBody[typeof MINDBOX_OPERATIONS.GET_CUSTOMER_BALANCE_HISTORY]
    | ResponseError;
  data?: {
    title: string;
    levelExplorer: LevelData;
    levelInnovator: LevelData;
    levelAmbassador: LevelData;
  };
};

export function MainInfo({
  customerInfo,
  customerBalanceHistory,
  data
}: MainInfoProps) {
  const slots = styles();
  const t = useTranslations();
  const levelsRef = useRef<HTMLDivElement>(null);

  if (
    ('error' in customerInfo && customerInfo?.error !== null) ||
    'error' in customerBalanceHistory ||
    !('balances' in customerInfo)
  ) {
    return null;
  }
  const { available } = customerInfo?.balances[0];

  let {
    customFields: { loyaltyLevel, referalCode }
  } = customerInfo?.customer;

  const pluralizeBalance = utilPluralize({
    one: t('pluralize.balance.one'),
    few: t('pluralize.balance.few'),
    many: t('pluralize.balance.many')
  });
  const levels = ['Explorer', 'Innovator', 'Ambassador'];

  if (!loyaltyLevel) {
    loyaltyLevel = levels[0];
  }
  const onLinkCopy = (code: string) => {
    navigator.clipboard.writeText(code).then(() => {
      toastBase(t('Code copied'));
    });
  };

  useEffect(() => {
    if (levelsRef.current) {
      const container = levelsRef.current;
      const items = container.children;
      const index = levels.indexOf(loyaltyLevel);
      if (items[index]) {
        container.scrollTo({
          left: (items[index] as HTMLElement).offsetLeft,
          behavior: 'smooth'
        });
      }
    }
  }, []);
  return (
    <div className={slots.base()}>
      <h1 className={slots.h1()}>{t('The Privilege Program')}</h1>
      <div className={slots.top()}>
        <div className={slots.topInfo()}>
          <IconBrand />
          <div className={slots.topContent()}>
            <p className={slots.topTitle()}>
              {t('Available to you')} {available} {pluralizeBalance(available)}
            </p>
            <p className={slots.topText()}>{data?.title}</p>
          </div>
        </div>
        {/* <p className={slots.topCount()}>1 400 баллов сгорят через 99 дней</p> */}
      </div>

      <div className={slots.content()}>
        <div
          className={slots.levels()}
          ref={levelsRef}
        >
          {levels.map((item) => (
            <div
              key={item}
              className={slots.level({ active: loyaltyLevel === item })}
            >
              <p className={slots.levelTitle()}>{item}</p>
              <div className={slots.levelInfo()}>
                <div className={slots.levelBonuses()}>
                  <p className={slots.levelLbl()}>{t('Your bonuses')}:</p>
                  <p className={slots.levelCashback()}>
                    {(data as Record<string, any>)[`level${item}`].text}
                  </p>
                </div>
                <p className={slots.levelNote()}>
                  {(data as Record<string, any>)[`level${item}`].condition}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className={slots.info()}>
          {/* @ts-ignore */}
          {data[`level${loyaltyLevel}`]?.action}
        </div>
        <div
          className={slots.line({
            mode: loyaltyLevel.toLowerCase() as levelStatus
          })}
        ></div>

        {!!customerBalanceHistory.customerActions &&
          customerBalanceHistory.customerActions.length && (
            <UiKitDrawerBase
              className="max-w-155"
              trigger={
                <p className={slots.historyLinkText()}>
                  {t('Accrual history')}
                  <ArrowIcon className={slots.historyLinkIcon()} />
                </p>
              }
              direction="right"
              withoutMobile
            >
              <AccrualHistory customerBalanceHistory={customerBalanceHistory} />
            </UiKitDrawerBase>
          )}
      </div>
      {loyaltyLevel === 'Ambassador' && referalCode && (
        <div className={slots.referral()}>
          <div className={slots.referralInfo()}>
            <p className={slots.referralTitle()}>
              {t('Your referral program code')}
            </p>
            <p className={slots.referralText()}>{t('Refferal note')}</p>
          </div>
          <div className={slots.referralCode()}>
            <UiKitInputBase
              classNameInput={slots.referralInput()}
              type="text"
              readOnly
              value={referalCode}
            />
          </div>
          <UiKitButtonBase
            className={slots.referralBtn()}
            color="white"
            onClick={() => onLinkCopy(referalCode)}
          >
            {t('Copy')}
          </UiKitButtonBase>
        </div>
      )}
    </div>
  );
}
